import { Link } from 'react-router-dom'

const Arrow = ({ color }: { color?: string }) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 0.46875C12.3392 0.46875 14.0482 0.932617 15.627 1.86035C17.1569 2.75553 18.3695 3.9681 19.2646 5.49805C20.1924 7.07682 20.6562 8.78581 20.6562 10.625C20.6562 12.4642 20.1924 14.1732 19.2646 15.752C18.3695 17.2819 17.1569 18.4945 15.627 19.3896C14.0482 20.3174 12.3392 20.7812 10.5 20.7812C8.66081 20.7812 6.95182 20.3174 5.37305 19.3896C3.8431 18.4945 2.63053 17.2819 1.73535 15.752C0.807617 14.1732 0.34375 12.4642 0.34375 10.625C0.34375 8.78581 0.807617 7.07682 1.73535 5.49805C2.63053 3.9681 3.8431 2.75553 5.37305 1.86035C6.95182 0.932617 8.66081 0.46875 10.5 0.46875ZM10.5 2.03125C8.9375 2.03125 7.48893 2.42188 6.1543 3.20312C4.86849 3.9681 3.8431 4.99349 3.07812 6.2793C2.29688 7.61393 1.90625 9.0625 1.90625 10.625C1.90625 12.1875 2.29688 13.6361 3.07812 14.9707C3.8431 16.2565 4.86849 17.2819 6.1543 18.0469C7.48893 18.8281 8.9375 19.2188 10.5 19.2188C12.0625 19.2188 13.5111 18.8281 14.8457 18.0469C16.1315 17.2819 17.1569 16.2565 17.9219 14.9707C18.7031 13.6361 19.0938 12.1875 19.0938 10.625C19.0938 9.0625 18.7031 7.61393 17.9219 6.2793C17.1569 4.99349 16.1315 3.9681 14.8457 3.20312C13.5111 2.42188 12.0625 2.03125 10.5 2.03125ZM11.0615 5.62012L16.0664 10.625L11.0615 15.6299L9.93848 14.5312L13.0635 11.4062H5.03125V9.84375H13.0635L9.93848 6.71875L11.0615 5.62012Z"
        fill={color ?? '#027219'}
      />
    </svg>
  )
}

export const languageES = {
  agegate: {
    button: 'Ingresar',
    title: '¿Eres mayor de edad?',
    description: (
      <p className="agegate__description">
        Ingresa tu año de nacimiento, queremos <br /> validar tu mayoría de edad
      </p>
    ),
    politics1: (
      <>
        Al confirmar, aceptas la{' '}
        <Link to="/privacy-politics" className="underline">
          política de privacidad
        </Link>
        ,{' '}
        <Link to="/terms-and-conditions" className="underline">
          términos y condiciones
        </Link>{' '}
        y{' '}
        <Link to="/cookies" className="underline">
          uso de cookies
        </Link>{' '}
        de este sitio web. Este sitio web utiliza cookies. Para obtener más información, lee nuestra{' '}
        <Link to="/privacy-politics" className="underline">
          política de privacidad
        </Link>{' '}
        y{' '}
        <Link to="/cookies" className="underline">
          uso de Cookies
        </Link>
        .
      </>
    ),
    politics2: <></>
  },
  profile: {
    view: {
      arrow: <img src={`${AZURE_BASE_URL}/profile-view-arrow.webp`} alt="Arrow" />
    },
    identification: {
      nav: 'Mi ID'
    },
    menu: {
      title: 'Mi perfil'
    },
    form: {
      information: {
        firstname: {
          label: 'NOMBRE',
          placeholder: 'Ingresa tu nombre'
        },
        lastname: {
          placeholder: 'Ingresa tu apellido'
        },
        nickname: {
          label: 'APODO (OPCIONAL)',
          placeholder: 'Apodo'
        },
        email: {
          label: 'E-MAIL'
        }
      }
    },
    state: 'Mis premios',
    stateNotFound: <>Aún no has ganado o canjeado ningún <br /> premio para hacerle el seguimiento.</>,
    pref: 'Mis preferencias'
  },
  lineup: {
    dateform: {
      description:
        'Para empezar selecciona una o varias fechas del festival para ver los artistas que se presentan y comienza a armar tu lineup personalizado.'
    },
    start: {
      'not-found': (
        <p className="description medium text-center">
          ¡Tu experiencia Coachella está a un paso! <br />
          Arma tu lineup ideal y prepárate para vivir el <br />
          festival como nunca antes. ¡Vamos a crearlo!
        </p>
      )
    }
  },
  social: {
    Ticket: {
      howToParticipate: {
        subtitle: 'SUBE TU TICKET Y PARTICIPA',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7">
            <li className="flex flex-row w-full gap-5 items-start">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-25.webp`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-bold text-lg industry leading-6" style={{ color: 'black' }}>
                  Completa tus datos personales
                </p>
                <p className="font-normal text-base leading-5 industry break-words" style={{ color: 'black' }}>
                  en el perfil de tu cuenta.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5 items-start">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-26.webp`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-bold text-lg industry leading-6" style={{ color: 'black' }}>
                  Sube una foto de tu recibo de compra
                </p>
                <p className="font-normal text-base leading-5 industry break-words" style={{ color: 'black' }}>
                  Donde se vea bien el detalle de lo que compraste.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5 items-start">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-27.webp`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-bold text-lg industry leading-6" style={{ color: 'black' }}>
                  Contesta la trivia
                </p>
                <p className="font-normal text-base leading-5 industry break-words" style={{ color: 'black' }}>
                  Luego de cargar tu ticket tendrás que contestar correctamente la trivia para poder participar por la
                  oportunidad de llevarse un pase doble al EDC 2025.
                </p>
              </div>
            </li>
            <div
              className="w-full border border-dashed p-2 flex items-center gap-2 rounded-lg mb-7"
              style={{ backgroundColor: 'rgba(2, 114, 25, 0.08)', borderColor: '#027219', color: '#027219' }}
            >
              <img src={`${AZURE_BASE_URL}/icon_tickets_xx.webp`} alt="Icono de tickets" />

              <p className="industry text-xs leading-normal flex-1">
                ¡ATENTO! Mientas más tickets de compras cargues tendrás mayores chances de ganar el pase doble a EDC
                2025.
              </p>
            </div>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal industry text-base">
                    El ticket debe ser de productos Dos Equis en alguna de sus presentaciones (XX Lager, XX Ambar, XX
                    Ultra Lager).
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal industry text-base">Se debe visualizar la fecha de compra.</p>
                </div>
              </div>
              {/* <div className="w-full flex gap-5 justify-center">
                  <Arrow />
                  <div className="flex-1">
                    <p className="text-black font-normal industry text-base" style={{ wordBreak: 'break-word' }}>
                      Puedes subir como máximo 3 tickets cada 24hrs.
                    </p>
                  </div>
                </div> */}
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal industry text-base">
                    No se permite cargar el mismo ticket más de una vez.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal industry text-base">
                    Los tickets validados añadirán puntos al perfil del usuario los cuales podrá usar para canjear
                    premios en la vitrina.
                  </p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        buttonSubmit: 'Si, añadir',
        title: 'Cargar ticket',
        subtitle: 'Clic para agregar tu ticket',
        rules: {
          title: 'REGLAS PARA SUBIR TICKETS',
          list: (
            <ul>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Busca en las imágenes de tu dispositivo la foto del recibo que quieres cargar.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Asegúrate de que el recibo tenga la información importante de forma legible.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> Intenta que la foto del recibo esté bien encuadrada y sin otros elementos.
                </p>
              </li>
            </ul>
          )
        },
        'ranking-subtitle': {
          progress: (
            <>
              Este es el ranking con las historias más votadas. <br /> Dale clic a la que más te guste para votarla.
            </>
          ),
          completed: (
            <>
              Este reto ya ha finalizado y no se puede votar, <br /> pero puedes leer las historias ganadoras.
            </>
          )
        },
        alreadyUploaded: {
          description: 'Se ha agregado correctamente tu ticket.',
          button: {
            url: '/album/congrats',
            text: '¡VAMOS!'
          }
        },
        errorModalValidate: {
          description: <>No puedes subir tu ticket debido a:</>,
          list: (
            <div style={{ width: '320px' }}>
              <div className="list">
                <p className="ml-5">
                  {' '}
                  <span className="font-bold">• Llegaste al máximo de tickets que puedes cargar en 1 día. </span>{' '}
                  (puedes subir máx. 2 tickets consecutivos por día).
                </p>
              </div>
              <div className="list mt-2">
                <p className="ml-5">
                  {' '}
                  <span className="font-bold">• Llegaste al máximo de tickets que puedes cargar en total </span>{' '}
                  (puedes subir máx. 24 recibos).
                </p>
              </div>
            </div>
          ),
          help: (
            <div style={{ width: '320px' }} className="flex justify-center items-center flex-col mb-12 help">
              <span className="font-bold text-black text-center text-base industry title">
                ¿Te parece que no es así?
              </span>
              <span className="text-center text-black text-base industry subtitle">
                Ponte en contacto con nosotros para que <br /> podamos ayudarte.{' '}
                <Link to="/help" className="underline">
                  Envíanos un mensaje.
                </Link>{' '}
              </span>
            </div>
          )
        },
        buttonCancel: 'No, elegir otra imágen',
        isReady: '¿Estás OK con esta imagen?'
      },
      congrats: {
        description: (
          <>
            Obtuviste <b>VAR_TITLE</b>
          </>
        ),
        button1: 'CONTESTAR LA TRIVIA',
        button2: 'QUIERO CARGAR OTRO TICKET',
        button2Link: '/album/redirect/Ticket/upload',
        button3: 'VOLVER AL HOME',
        button3Link: '/home'
      },
      config: {
        prizes: '/trivia/qr/45' // Trivia seteada para PROD
      }
    },
    Card: {
      // title: 'Un brindis por los mejores momentos',
      maxLength: 50,
      placeholder: 'INGRESA TU FRASE AQUÍ...',
      backButton: 'VOLVER',
      upload: {
        textPhrase: (
          <>
            Mi mejor <br />
            recuerdo de la <br />
            UCL fue cuando
          </>
        ),
        rules: {
          list: (
            <ul style={{ color: '#15141A', fontSize: '14px', fontFamily: 'Industry-Book', fontWeight: 400 }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Completa la frase de la imagen con tu mejor recuerdo de la UCL en el recuadro que dice &quot;Ingresa tu frase aquí...&quot;.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Tienes que armar tu frase en 50 caracteres cómo máximo.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> Revisa cómo queda la imagen final para aprobarla o volver a hacerlo.
                </p>
              </li>
            </ul>
          )
        }
      }
    },
    Foto: {
      upload: {
        title: 'Paso 2: Sube tu foto con un producto Heineken',
        subtitle: 'Clic para agregar tu foto',
        rules: {
          title: 'REGLAS PARA SUBIR TU FOTO',
          list: (
            <ul>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Tiene que ser una foto tuya acompañado de un producto Heineken.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> No deben aparecer menores de edad.
                </p>
              </li>
            </ul>
          )
        },
        buttonSubmit: 'Si, añadir',
        buttonCancel: 'No, elegir otra imágen',
        isReady: '¿Estás OK con esta imagen?',
      },
      congrats: {
        description: (
          <>
            Ya estas participando para obtener la <b>VAR_TITLE</b>.
          </>
        ),
        button1: 'Paso 3: Completar mis datos',
      },
    },
    loader: {
      title: (
        <>
          Estamos <br /> validando
        </>
      )
    }
  },
  backButton: 'Volver al home',
  error: {
    1114: {
      title: 'No hemos podido validar tu imagen'
    },
    8003: {
      title: '¡Listo! Has editado tu lineup',
      description: ' ',
      button: {
        text: 'Continuar'
      }
    },
    505: {
      title: '¡Oh, no! Fallaste',
      description: 'Recuerda que puedes intentarlo nuevamente, ¡échale ganas!',
      button: {
        text: 'Ver más trivias',
        link: '/trivias'
      }
    },
    8001: {
      title: '¡Atención! Revisa tu selección',
      description: (
        <>
          <b>Has elegido dos artistas que tocan en el mismo horario.</b>
          <br />
          <br />
          No es necesario que hagas cambios si no quieres, pero ten en cuenta que se superponen esos artistas y tal vez
          tengas que elegir uno o correr para ver ambos.
        </>
      ),
      button: {
        text: 'Comprendo'
      }
    },
    10: {
      description: <>Dele click en REENVIAR para recibir otro código e intentarlo de nuevo.</>
    },
    50: {
      description: 'Tu cuenta aún no fue validada, te hemos enviado un email para avanzar'
    },
    9630: {
      title: '¡Gracias por escribirnos!',
      description: 'Recibimos tu mensaje. Danos un par de días para contestarte y estamos seguros que te vamos a poder ayudar. Recuerda que te llegará la respuesta por mail.',
      button: {
        text: 'Volver'
      }
    },
  },
  help: {
    textArea: {
      button: 'Enviar mensaje'
    }
  },
  collections: {
    found: 'COMPLETADO',
    popup: (
      <div className="flex-1 w-full pt-8 px-4">
        <div className="text-center pb-8">
          <h2 className="title medium">¿COMO PARTICIPAR?</h2>
          <p className="subtitle medium">consigue todos los DESAFíOS y gana</p>
        </div>
        <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7">
          <li className="flex flex-row w-full gap-5">
            <img src={`${AZURE_BASE_URL}/cuenta_icon.svg`} />
            <div className="flex-1 flex flex-col justify-center">
              <p
                className="text-base font-normal industry leading-normal"
                style={{ fontFamily: 'Industry', color: '#000000' }}
              >
                <b>Completa tu perfil</b>
                <br />
                Termina de armar tu cuenta con tus datos personales.
              </p>
            </div>
          </li>
          <li className="flex flex-row w-full gap-5">
            <img src={`${AZURE_BASE_URL}/cargar-frase_icon.svg`} />
            <div className="flex-1 flex flex-col justify-center">
              <p
                className="font-normal text-base industry leading-normal"
                style={{ fontFamily: 'Industry', color: '#000000' }}
              >
                <b>Entra al juego</b>
                <br />
                Participa en los desafíos semanales y gana un sello por cada uno que completes.
              </p>
            </div>
          </li>
          <li className="flex flex-row w-full gap-5">
            <img src={`${AZURE_BASE_URL}/ranking_icon.svg`} />
            <div className="flex-1 flex flex-col justify-center">
              <p
                className="font-normal text-base industry leading-normal"
                style={{ fontFamily: 'Industry', color: '#000000' }}
              >
                <b>Completa el juego</b>
                <br />
                Consigue todos los sellos en el menor tiempo posible para ganar merch oficial y única de Dos Equis y El
                Juego del Calamar.
              </p>
            </div>
          </li>
        </ul>
        <div
          className="w-full border border-dashed p-2 flex items-center gap-2 rounded-lg mb-7"
          style={{ backgroundColor: 'rgba(2, 114, 25, 0.08)', borderColor: '#027219', color: '#027219' }}
        >
          <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="48" height="48" rx="24" fill="white" />
            <path
              d="M24.9287 37.5714C32.424 37.5714 38.5002 31.4953 38.5002 24C38.5002 16.5047 32.424 10.4286 24.9287 10.4286C17.4334 10.4286 11.3573 16.5047 11.3573 24C11.3573 31.4953 17.4334 37.5714 24.9287 37.5714Z"
              stroke="#B98B22"
              strokeWidth="2.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.9286 18.5715V24"
              stroke="#B98B22"
              strokeWidth="2.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.9286 29.4286H24.9428"
              stroke="#B98B22"
              strokeWidth="2.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p className="industry text-xs leading-normal flex-1">
            ¡Atención! El juego se reinicia <b>cada lunes</b>. Por lo que puedes volver a participar cada semana.{' '}
          </p>
        </div>
      </div>
    )
  },
  trivias: {
    'not-found': 'No hay trivias disponibles por el momento. Regresa al calendario y participa de los demás retos.',
    triviaQr: {
      register: {
        html: (
          <div className='flex-1 w-full flex flex-col gap-6 px-7 pt-7'>
            <h2>
              ¡Contesta y gana!
            </h2>

            <img src={`${AZURE_BASE_URL}/trivia-qr-card-id.webp`} alt="Heineken ID" />

            <div>
              <h3>¿Ya tienes tu ID?</h3>

              <p className="mt-2">
                Si no lo tienes córrele a registrarte para poder participar.
              </p>
            </div>
          </div>
        )
      }
    }
  },
  referrals: {
    title: 'Referidos',
    code: {
      title: 'Comparte tu código para obtener oportunidades con cada nuevo referido y participa por Entradas a la fiesta Heineken UCL o una Hielera.',
      dynamic: {
        content: (
          <>
            <div className="flex gap-2 items-center pb-2">
              <div className="w-5 h-5 rounded-full" style={{ background: '#D9D9D9' }} />
              <p className="text medium flex-1">Cada amigo que refieras y se registre <b>suma 10 oportunidades</b>.</p>
            </div>
            <div className="flex gap-2 items-center pb-6">
              <div className="w-5 h-5 rounded-full" style={{ background: '#D9D9D9' }} />
              <p className="text medium flex-1">Podrás referir hasta 5 amigos como máximo.</p>
            </div>
          </>
        )
      }
    }
  },
  wheelFortune: {
    description: {
      'onchances': 'GIRA LA RUEDA Y ESPERA A VER QUE TE TOCA ',
      'not-chances': 'GIRA LA RUEDA Y ESPERA A VER QUE TE TOCA '
    },
    rules: (
      <>
        <div className="flex items-center gap-2">
          <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.35938 0.390625L11.6094 4.64062L11.9531 5L11.6094 5.35938L7.35938 9.60938L6.64062 8.89062L10.0312 5.5H0V4.5H10.0312L6.64062 1.10938L7.35938 0.390625Z"
              fill="white"
            />
          </svg>
          <p className="flex-1 text medium" style={{ fontSize: '14px' }}>
            Participar en el reto &quot;Sube tu ticket&quot;.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.35938 0.390625L11.6094 4.64062L11.9531 5L11.6094 5.35938L7.35938 9.60938L6.64062 8.89062L10.0312 5.5H0V4.5H10.0312L6.64062 1.10938L7.35938 0.390625Z"
              fill="white"
            />
          </svg>
          <p className="flex-1 text medium" style={{ fontSize: '14px' }}>
            Obtendrás 1 chance de girar la rueda por cada ticket válido que subas.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.35938 0.390625L11.6094 4.64062L11.9531 5L11.6094 5.35938L7.35938 9.60938L6.64062 8.89062L10.0312 5.5H0V4.5H10.0312L6.64062 1.10938L7.35938 0.390625Z"
              fill="white"
            />
          </svg>
          <p className="flex-1 text medium" style={{ fontSize: '14px' }}>
            Podrás obtener 2 chances cómo máximo por día.{' '}
          </p>
        </div>
      </>
    )
  },
  groups: {
    start: {
      title: 'Brindemos con los que siempre están',
      'owner-title': 'INVITAR',
      'not-found-owner': <>Aún no has invitado a esa persona con la que <br /> irías a la final de la UCL ¿Qué esperas?</>
    }
  },
  survey: {
    button: 'Responder',
    onboarding: {
      html: (
        <div className='flex-1 w-full flex flex-col gap-6 px-7 pt-7'>
          <h2>
            ¡Contesta y gana!
          </h2>

          <img src={`${AZURE_BASE_URL}/trivia-qr-card-id.webp`} alt="Heineken ID" />

          <div>
            <h3>¿Ya tienes tu ID?</h3>

            <p className="mt-2">
              Si no lo tienes córrele a registrarte para poder participar.
            </p>
          </div>
        </div>
      )
    }
  }
}
